<template>
  <div>
    <v-flex  v-if="isLoading" xs12 pa-2 class="text-xs-center">
      <v-progress-circular :size="48" :width="5" color="primary" indeterminate></v-progress-circular>
    </v-flex>
    <v-data-table
        style="width: 100%"
        v-if="!isLoading"
        :headers="headers"
        :items="finalDocuments"
        :options.sync="pagination"
        :server-items-length="serverItemsLength"
    >
      <template v-slot:item="props">
        <tr :style="{ backgroundColor: getRowColor(props.item.no_of_days) }">
          <td style="width: 7%">{{ props.item.state }}</td>
          <td style="width: 7%">{{ props.item.obj_id }}</td>
          <td style="width: 7%">{{ props.item.name }}</td>
          <td :style="{ width: '7%', fontWeight: checkForMandatoryDoc(props.item.type) ? 'bold' : 'normal' }">{{ props.item.type }}</td>
          <td style="width: 7%">
            <a
                v-on:click.stop="doNothing()"
                :href="
                'tel:' + formatNumber(props.item.contact_number)
              "
            >{{ props.item.contact_number }}</a
            >
          </td>
          <td style="width: 7%">
            {{ props.item.expiry_time }}
          </td>
          <td style="width: 7%">
            {{getActualNumOfDays(props.item.no_of_days)}}
          </td>
          <td style="width: 7%">
            {{ props.item.council }}
          </td>

          <td style="width: 25%">
            <v-row>
              <v-btn
                  v-if="
                  props.item.state == 'completed' ||
                  props.item.state == 'rejected'
                "
                  @click="resendReminder(props.item.driver.id)"
                  x-small
                  style="">
                Resend Reminder
              </v-btn>
              <v-btn
                  v-if="props.item.state == 'pending'
                  || props.item.state == 'completed'
                  || props.item.state == 'rejected'"
                  @click="viewDoc(props.item)"
                  x-small
                  style="">
                View Document
              </v-btn>
              <v-btn @click="viewDocument(props.item)" x-small style="">
                Upload Document
              </v-btn>
            </v-row>
          </td>

          <td
              v-if="props.item.state == 'requires_verification'"
              style="width: 5%"
          ></td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="viewFileDialog" width="800">
      <template v-slot:activator="{ on, attrs }"></template>

      <v-card v-if="viewFileDialog == true && fetchedDriverDocument != null">
        <v-card-title class="headline grey lighten-2">
          Uploaded Document
        </v-card-title>

        <v-col>
          <v-row>
            <v-flex shrink pt-2
            >
              <v-date-picker
                  v-model="dateForNewDocument"
              ></v-date-picker
              >
            </v-flex>
            <v-col>
              <v-row class="flex-nowrap">
                <FileInput
                    label="Upload Document"
                    icon="insert_drive_file"
                    accept="*"
                    @fileInput="handleDocumentInput"
                />
              </v-row>
              <v-row v-if="fetchedDriverDocument.filename != null" class="flex-nowrap">
                <v-btn @click="handleViewDocument" small>Download Driver Uploaded Document</v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-col>

        <v-flex px-3>
          <p style="color: red;" v-if="fetchedDriverDocument.filename == null && uploadedFile == null">
            You must upload a file or ask driver to upload file before you can resolve this document expiry.
          </p>
        </v-flex>

        <v-divider></v-divider>

        <v-card-actions>

          <v-spacer></v-spacer>
          <v-btn color="black" text @click="viewFileDialog = false">Close</v-btn>
          <v-btn v-if="fetchedDriverDocument.filename != null" color="black" text @click="reject">Reject</v-btn>
          <v-btn
              v-if="fetchedDriverDocument.filename != null || uploadedFile != null"
              color="green" text
              @click="accept">
            Accept
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {replaceStart} from "@/components/util/PhoneNumbers.js";
import axios from "axios";
import AttributesForTaxiCell from "@/components/widget/AttributesForTaxiCell.vue";
import FileInput from "@/components/widget/input/FileInput.vue";

axios.defaults.withCredentials = true;

export default {
  name: "driver_documents_list",
  components: {
    AttributesForTaxiCell,
    FileInput,
  },
  props: {
    query: Object,
  },
  data: function () {
    return {
      uploadedFile: null,
      fetchedDriverDocumentURL: null,
      fetchedDriverDocument: null,
      dateForNewDocument: new Date().toISOString().substr(0, 10),
      serverItemsLength: null,
      selectedItem: null,
      viewFileDialog: false,
      rideTypes: [],
      pagination: {},
      headers: [
        {
          text: "Status",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "ID",
          align: "left",
          sortable: false,
          value: "id",
        },
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "Document",
          align: "left",
          sortable: false,
          value: "document",
        },

        {
          text: "Contact Number",
          align: "left",
          sortable: false,
          value: "contact_number",
        },
        {
          text: "Expiry Date",
          align: "left",
          sortable: false,
          value: "document",
        },
        {
          text: "No Of Days To Expiry",
          align: "left",
          sortable: false,
          value: "no_of_days_to_expiry",
        },
        {
          text: "Council",
          align: "left",
          sortable: false,
          value: "council",
        },
        {
          text: "Actions",
          align: "left",
          sortable: false,
          value: "taxi",
        },
      ],
      taxi_doc_types: [
        "insurance",
        "mot",
        "vehicle_plate",
        "compliance_certificate",
        "road_tax",
      ],
      driverDocuments: [],
      taxiDocuments: [],
      isLoading: true,
    };
  },
  mounted: async function () {
    console.log("MOUNTED");
    await this.getPhotoEntries();
  },
  computed: {
    finalDocuments: function() {

      var finalDocs = [];

      for (var i = 0; i < this.driverDocuments.length; i++) {

        let doc = {
          id: this.driverDocuments[i].id,
          state: this.driverDocuments[i].state,
          obj_id: this.driverDocuments[i].driver.callsign,
          name: this.driverDocuments[i].driver.user.name,
          contact_number: this.driverDocuments[i].driver.user.contact_number,
          type: this.driverDocuments[i].type,
          expiry_time: this.driverDocuments[i].expiry_time,
          filename: this.driverDocuments[i].filename,
          council: this.driverDocuments[i].council,
          no_of_days: this.driverDocuments[i].no_of_days,
        }

        finalDocs.push(doc);
      }

      for (var i = 0; i < this.taxiDocuments.length; i++) {

        let doc = {
          id: this.taxiDocuments[i].id,
          state: this.taxiDocuments[i].state,
          obj_id: this.taxiDocuments[i].taxi.id,
          name: this.taxiDocuments[i].taxi.registration_number,
          contact_number: this.taxiDocuments[i].taxi.plate_number,
          type: this.taxiDocuments[i].type,
          expiry_time: this.taxiDocuments[i].expiry_time,
          filename: this.taxiDocuments[i].filename,
          council: this.taxiDocuments[i].council,
          no_of_days: this.taxiDocuments[i].no_of_days,
        }

        finalDocs.push(doc);
      }

      return finalDocs;
    }
  },
  watch: {
    pagination: {
      handler() {
        this.getPhotoEntries();
      },
      deep: true,
    },
  },
  methods: {
    async verdict(accept) {
      try {
        let response = await axios.post(
            `${this.$store.state.apiUrl}/driver_document_expiry/documentVerdict?id=${this.fetchedDriverDocument.id}&accept=${accept}&expiry_time=${this.dateForNewDocument}`,
            {},
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
        );

        if (response.data.error == "no_error") {
          this.viewFileDialog = false;
          this.refresh();

          alert("Done");
        } else {
          if (response.data.message != null) {
            alert(response.data.message);
          } else {
            alert(response.data.error);
          }
        }
      } catch (error) {
        console.log(error);
        return "unknown_error";
      }
    },
    async uploadAndAccept() {
      console.log("Fetched Document: ", this.fetchedDriverDocument);
      this.uploadedFile.expiry_time = this.dateForNewDocument;
      this.uploadedFile.id = this.fetchedDriverDocument.id;

      console.log("Uploaded File: ", this.uploadedFile);

      let document = {
        document_type: this.fetchedDriverDocument.type,
        file: this.uploadedFile,
        expiry_time: this.dateForNewDocument,
      }

      for(var i = 0; i < this.taxi_doc_types.length; i++) {
        if(this.fetchedDriverDocument.type === this.taxi_doc_types[i]) {
          document.taxi_id = this.fetchedDriverDocument.obj_id;
          break;
        }
      }

      if(document.taxi_id == null) {
        document.driver_id = this.fetchedDriverDocument.obj_id;
      }

      console.log(document);

      try {
        let response = await axios.post(
            `${this.$store.state.apiUrl}/driver_document_expiry/upload_document`,
            document,
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
        );

        if (response.data.error == "no_error") {
          this.viewFileDialog = false;
          this.refresh();
          alert("File Uploaded and Expiry Updated");
        } else {
          if (response.data.message != null) {
            alert(response.data.message);
          } else {
            alert(response.data.error);
          }
        }
      } catch (error) {
        console.log(error);
        return "unknown_error";
      }
    },
    reject() {
      this.verdict(false);
    },
    accept() {
      if (this.uploadedFile != null) {
        this.uploadAndAccept();
      } else {
        this.verdict(true);
      }
    },
    handleDocumentInput(file) {
      console.log("Uploaded file set");
      this.uploadedFile = file;
    },
    refresh() {
      console.log("Refresh Docs");
      this.getPhotoEntries();
    },
    clearAndRefresh() {
      console.log("boom");

      this.pagination.page = 1;
      this.getPhotoEntries();
    },
    viewDocument: async function (ddu) {
      this.viewFileDialog = true;

      this.fetchedDriverDocument = ddu;
      this.fetchedDriverDocumentURL = null;
      this.uploadedFile = null;

      if (ddu.expiry_time != null) {
        this.dateForNewDocument = ddu.expiry_time;
      }
    },
    viewDoc: async function (ddu) {
      this.fetchedDriverDocument = ddu;
      this.handleViewDocument();
    },
    handleViewDocument: function () {
      let self = this;
      var url = `${this.$store.state.apiUrl}/driver_document_expiry/getDocumentUrl`;

      axios({
        url: url,
        method: "GET",
        params: {
          key: this.fetchedDriverDocument.filename,
        },
      })
          .then(function (response) {
            if (response.data.error) {
              console.log(response.data.error);
            } else {
              const link = document.createElement("a");
              link.href = response.data.url;
              link.target = "_blank";
              link.setAttribute("download", self.fetchedDriverDocument.filename);
              document.body.appendChild(link);
              link.click();
            }
          })
          .catch(function (error) {
            console.log(error);
          });
    },
    resendReminder: async function (id) {
      try {
        let response = await axios.post(
            `${this.$store.state.apiUrl}/driver_document_expiry/sendExpiryReminderToDriver?driverId=${id}`,
            {},
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
        );

        if (response.data.error == "no_error") {
          alert("Reminder Resent");
        } else {
          if (response.data.message != null) {
            alert(response.data.message);
          } else {
            alert(response.data.error);
          }
        }
      } catch (error) {
        console.log(error);
        return "unknown_error";
      }
    },
    formatNumber: function (number) {
      return replaceStart(number);
    },
    getPhotoEntries: async function () {
      // this.isLoading = true;
      console.log("Get Photo Entries");

      const {page, itemsPerPage} = this.pagination;

      console.log("Pagination " + JSON.stringify(this.pagination));

      try {
        var url = `${
            this.$store.state.apiUrl
        }/driver_document_expiry/list?
        offset=${itemsPerPage * (page - 1)}&count=${itemsPerPage}&filter=${this.query.filter}&locked_out=${this.query.lockedOut}`;

        console.log(url);

        let response = await axios.get(url, {
          params: {},
        });

        const driverDocuments = response.data.driver_document_expiry_reminders;
        const taxiDocuments = response.data.taxi_document_expiry_reminders;

        this.driverDocuments = driverDocuments;
        this.taxiDocuments = taxiDocuments;

        this.serverItemsLength = response.data.pages.total;

      } catch (error) {
        console.log("Failed to get photos " + error);
      } finally {
        this.isLoading = false;
      }

      console.log("isLoading: ", this.isLoading);
    },
    checkForMandatoryDoc: function (documentType) {
      // let mandatoryDocs = ['dvla_license', 'profile_picture', 'proof_of_address', 'private_hire_license', 'hackney_license', 'form_b', 'dbs', 'operators_license', 'public_liability_insurance', 'employers_liability_insurance']
      let mandatoryDocs = ['dvla_license', 'private_hire_license', 'hackney_license', 'insurance', 'mot', 'vehicle_plate', 'compliance_certificate', 'road_tax']
      return mandatoryDocs.includes(documentType)
    },
    getRowColor: function(num_of_days){
      if(num_of_days === 'expired'){
        return '#ff3535';
      }

      if(num_of_days < 0){
        return '#ff3535';
      }

      return '';
    },
    getActualNumOfDays: function(num_of_days){
      if(num_of_days === 'expired'){
        return 'Expired';
      }

      if(num_of_days < 0){
        return -1 * num_of_days;
      }

      return num_of_days;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px;
}

.fixed-booking-table-row {
  overflow: hidden;
  height: 18px;
}
</style>
